<template>
  <b-form @submit.prevent="submit" class="mb-5">
    <b-row>
      <b-col md="6" lg="6">
        <b-form-group :label="$t('NAME')">
          <b-form-input :disabled="onlyRead" type="text" v-model="name"></b-form-input>
          <app-validation-description :show="$v.name.$dirty && $v.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="6">
        <b-form-group :label="$t('CITY')">
          <b-form-input :disabled="onlyRead" type="text" v-model="city"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="6">
        <b-form-group :label="$t('EMAIL')">
          <b-form-input :disabled="onlyRead"  type="email" v-model="email"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="6">
        <b-form-group :label="$t('PHONE')">
          <b-form-input :disabled="onlyRead" type="text" v-model="phone"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!onlyRead">
      <b-col>
        <app-button-submit :loading="loading" ></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {toast} from '@/shared/plugins/toastr'
import {getErrorMessage} from '@/mixins/error/getErrorMessage'
import AppButtonSubmit from '@/components/app/AppSubmit'
import ValidationDescription from '@/components/app/form/AppValidationDescription'
import {required} from "vuelidate/lib/validators";
import {cloneDeep} from "lodash";
import AppValidationDescription from "@/components/app/form/AppValidationDescription.vue";
import {
  createCompetentAuthority,
  updateCompetentAuthority
} from "@/services/competentAuthority";
import {mapActions} from "vuex";
export default {
  name: "CompetentAuthorityForm",
  mixins: [getErrorMessage],
  props:{
    detail: {
      type: Object
    },
    language: {
      type: String,
      default: 'bs'
    },
    headerId: {
      type: Number,
    },
    onlyRead: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return{
      name: null,
      city: null,
      email: null,
      phone: null,
      disabled: true,
      loading:false,
    }
  },
  validations:{
    name:{required},
  },
  components: {
    AppValidationDescription,
    AppButtonSubmit, ValidationDescription
  },
  methods:{
    ...mapActions('competentAuthority','actionSetCompetentAuthorities'),
    submit() {
      this.$v.$touch()
      if(this.$v.$invalid){
        toast({
          'title': this.$t('VALIDATION_FAILED'),
          'message': null,
          'type': 'error',
          'timeout': 6000
        })
        return
      }
      this.loading = true;
      let request = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        city: this.city,
        language: this.language
      }
      let apiCall;
      if(this.headerId) {
        apiCall = updateCompetentAuthority(this.headerId, request)
      } else {
        apiCall = createCompetentAuthority(request)
      }
      apiCall.then((response) => {
        toast({
          title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
          message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
          type: 'success',
          timeout: 3000
        })
        this.$emit('success', response.data.id);
        this.$store.dispatch('competentAuthority/actionSetCompetentAuthorities')
      },(error) =>{
        toast({
          title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
          message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
          type: 'error',
          timeout: 6000
        })
      }).finally(() =>{
        this.loading = false;
      })
    },
    setData(detail) {
      const competentAuthorityDetail = cloneDeep(detail);
      if(competentAuthorityDetail) {
        this.name = competentAuthorityDetail.name;
        this.city = competentAuthorityDetail.city;
        this.email = competentAuthorityDetail.email;
        this.phone = competentAuthorityDetail.phone;
      }

    }
  },
  async mounted() {
    await this.setData(this.detail);
  }
}
</script>

<style scoped>

</style>
